import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

export type FeedbackType = 'success' | 'error' | 'info' | 'warning';

@Component({
  selector: 'app-feedback-overlay',
  templateUrl: './feedback-overlay.component.html',
  styleUrls: ['./feedback-overlay.component.css'],
  animations: [
    trigger('overlayAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('300ms ease-in', style({ opacity: 0 }))]),
    ]),
    trigger('iconAnimation', [
      transition(':enter', [
        style({ transform: 'scale(0.5)', opacity: 0 }),
        animate('400ms ease-out', style({ transform: 'scale(1)', opacity: 1 })),
      ]),
    ]),
  ],
})
export class FeedbackOverlayComponent implements OnInit {
  @Input() type: FeedbackType = 'success';
  @Input() message = '';
  @Input() detailMessage?: string;
  @Input() duration = 2000;
  @Input() showIcon = true;
  @Input() showBackground = true;
  @Input() actionButtonText?: string;
  @Input() cancelButtonText?: string;
  @Input() preventAutoClose = false;
  @Input() supportEmail?: string;
  @Input() supportEmailSubject?: string;
  @Output() closed = new EventEmitter<void>();
  @Output() actionButtonClick = new EventEmitter<void>();
  @Output() cancelButtonClick = new EventEmitter<void>();

  visible = false;

  ngOnInit() {
    this.visible = true;
    if (this.duration > 0 && !this.preventAutoClose) {
      setTimeout(() => {
        this.visible = false;
        setTimeout(() => {
          this.closed.emit();
        }, 300); // Wait for animation to complete
      }, this.duration);
    }
  }

  get supportMailtoHref(): string {
    const subject = this.supportEmailSubject
      ? `?subject=${encodeURIComponent(this.supportEmailSubject)}`
      : '';
    return `mailto:${this.supportEmail}${subject}`;
  }

  getIcon(): string {
    switch (this.type) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'error';
      case 'info':
        return 'info';
      case 'warning':
        return 'warning';
      default:
        return 'check_circle';
    }
  }

  close() {
    this.visible = false;
    setTimeout(() => {
      this.closed.emit();
    }, 300); // Wait for animation to complete
  }

  onActionButtonClick() {
    this.actionButtonClick.emit();
  }

  onCancelButtonClick() {
    this.cancelButtonClick.emit();
  }
}
